import { Box, IconButton, Typography, Stack, ButtonBase, styled } from "@mui/material"
import { t } from "i18next"
import Modifier from "./Modifier"
import ModifierStatusList from "./ModifierStatus"
import OrderBox from "./OrderBox"
import { useItemDetail } from "./ItemDetailContext"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { useWindowDimensions } from "../../../App"
import { useInfoStore } from "../../../store/userInfo"
import { useOrderStore } from "../../../store/order"
import { useRef, useState, useMemo, useEffect } from "react"
import RecommendView from "../Recommend/RecommandView"
import { useMenuStore } from "../../../store/menuState"
import { isAndroid } from "react-device-detect"
import { useTranslation } from "react-i18next"
import { logger } from "../../../utils/logger"
import { isBrowser } from "react-device-detect";
import DrawerOrderBox from "./DrawerOrderBox"
import LazyPictureWithSkeleton from "../../../components/LazyPictureWithSkeleton";

const IMAGE_URL = process.env.REACT_APP_S3_IMAGE_PAPH;
const LazyPicture = styled(LazyLoadImage)`
  object-fit: cover;
  width: ${({ width }) => (width ? `${width}rem` : "100%")};
  height: ${({ width }) => (width ? `${width}rem` : "100%")};
  border-radius: 1.5rem;
`;

/**
 * MIME 타입 추출 함수
 */
const getMimeType = (imagePath: string): string => {
  const extension = imagePath.split(".").pop()?.toLowerCase();
  switch (extension) {
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "webp":
      return "image/webp";
    case "gif":
      return "image/gif";
    default:
      return "application/octet-stream"; // 기본 MIME 타입
  }
};

const PortraitDetail = () => {
    const { itemDetail, selectRequired, setSelectRequired, setItemDetail, handleClose, handleAddCount, handleSubCount, handleAddtoCart, checkLimitCountText } = useItemDetail();
    const { userInfo, currentLng } = useInfoStore();
    const storeId = userInfo?.storeId;
    const {t} =  useTranslation(`${storeId}`)
    const { menuDao } = useMenuStore()
    const { width, height } = useWindowDimensions()
    const { preOrder, orderTotalPrice, checkedModifierPrice } = useOrderStore();
    const [openOrderBox, setOpenOrderBox] = useState(false);

    // 네이티브 이미지 캐시 관련 ref 및 강제 리렌더링용 상태
    const base64CacheRef = useRef(new Map<string, string>());
    const [nativeImageVersion, setNativeImageVersion] = useState(0);
    const [imageSrc, setImageSrc] = useState('')
        /**
     * menuDao를 ID 기준으로 매핑
     */
    const menuMap = useMemo(() => {
      const map = new Map();
      menuDao.forEach((menu: any) => {
        map.set(menu.id, menu);
      });
      return map;
    }, [menuDao]);

    let menuItem = null;
    let webImagePath = ''
    let androidImagePath = ''
    const TRANSPARENT_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    const defaultImage = "/assets/images/no_image.png";
    const getBase64ImageSrc = (imagePath: string | null): string => {
      if (!imagePath) return defaultImage;
      if (base64CacheRef.current.has(imagePath)) {
        return base64CacheRef.current.get(imagePath)!;
      }

      // 네이티브 Android 호출을 비동기 처리하여 캐시 업데이트 및 재렌더 유도
      setTimeout(() => {
        const base64Image = window.Android?.getImageAsBase64(imagePath);
        if (base64Image) {
          const mimeType = getMimeType(imagePath);
          const src = `data:${mimeType};base64,${base64Image}`;
          base64CacheRef.current.set(imagePath, src);
          // 강제 리렌더를 위해 상태 업데이트 (nativeImageVersion 값은 사용하지 않음)
          setNativeImageVersion(v => v + 1);
        }
      }, 0);
      return TRANSPARENT_IMAGE;
    };

    useEffect(() => {
      if (itemDetail) {
        const menuItem = menuMap.get(itemDetail.itemId);
        const webImagePath = IMAGE_URL + `/${itemDetail.images[0]}`;
        const androidImagePath = menuItem?.images?.[0] ?? null;
        const src = isAndroid
          ? (androidImagePath ? getBase64ImageSrc(androidImagePath) : webImagePath)
          : webImagePath;
        
        setImageSrc(src);
      }
    }, [itemDetail, nativeImageVersion]);

    const handleOpenOrderBox = (e: React.TouchEvent<HTMLButtonElement> | React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
      logger.debug('open')
      e.stopPropagation();
      e.preventDefault()
      // if (!isBrowser) {
      //   if (window.ReactNativeWebView !== undefined) {
      //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
      //   } else if(window.Android !== undefined) {
      //     window.Android.postMessage(JSON.stringify({'type':'play'}));
      //   }
      // }
      setOpenOrderBox(true)
     }

    if(!itemDetail) return <></>
    return (
      <Box className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <Box sx={{background: '#fff', flexDirection: 'row', width: '100%', height: '6.8rem', borderRadius: '1.5rem 1.5rem'}}>
          <div className="touch-area"  onClick={handleClose}>
            <IconButton aria-label="close" style={{position: 'absolute', right: '2.0rem', top: '.5rem', width: '6.6rem', height: '6.6rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}} >
              <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <img style={{position: 'absolute',top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '6.6rem', height: '6.6rem', }}
                  src={process.env.PUBLIC_URL+'/assets/images/close_bg.svg'}
                  alt="close"
                />
                <img style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '2.0rem', height: '2.0rem',}}
                  src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'}
                  alt="close"
                />
              </div>
            </IconButton>
          </div>
        </Box>
        <Box sx={{width: width, display: 'flex', alignItems: 'flex-start', overflow: 'hidden'}}>
          {itemDetail.hasModifier && <Box sx={{width: '18.0rem'}}>
            <ModifierStatusList itemDetail={itemDetail} setItemDetail={setItemDetail} />
          </Box>}
          <Box sx={{flex: 1, p: itemDetail.hasModifier? '0rem 1.0rem 0rem 2.0rem': '0rem 5.0rem 1.0rem 5.0rem', overflow: 'hidden'}}>
            <Box sx={{ 
              height: `calc(calc(var(--vh, 1vh) * 100) - ${itemDetail.hasModifier ? '10.0rem': '10.0rem'})`,  
              mt: '1.0rem'
            }}>
              <Box sx={{overflow: 'auto', overflowX: 'hidden', pr: '-1.0rem', maxHeight: 'calc(100% - 10.0rem)' }}>
                <Stack  sx={{display: 'flex', flexDirection: 'column', gap: '2.0rem', mb: '2.0rem'}}>
                  { (!itemDetail?.images[0]? 
                    <Box sx={{ width: `100%`,  height: `calc(${width/10 * .36} * 16px)`, borderRadius: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#ccc'}}>
                      <Typography sx={{fontSize: '3.0rem',  textAlign: 'left', fontWeight: '500', color: 'rgba(255, 255, 255, 0.80)',  letterSpacing: '-.03rem'}}>
                        {t(`${storeId}:itemNames.${itemDetail.itemId}.${currentLng}`)}
                      </Typography>
                    </Box>
                    :
                    <Box sx={{ position: 'relative', width: `100%`, height: `calc(${width/10 * .36} * 16px)` }}>
                      {/* 스켈레톤 배경 + 아이템 이름 */}
                      <Box sx={{ 
                        position: 'absolute', 
                        top: 0, 
                        left: 0, 
                        width: '100%', 
                        height: '100%', 
                        borderRadius: '1.5rem', 
                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                        backgroundSize: '200% 100%',
                        animation: 'loading 1.5s infinite',
                        '@keyframes loading': {
                          '0%': { backgroundPosition: '200% 0' },
                          '100%': { backgroundPosition: '-200% 0' }
                        },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1
                      }}>
                        <Typography sx={{fontSize: '3.0rem',  textAlign: 'left', fontWeight: '500', color: 'rgba(255, 255, 255, 0.80)',  letterSpacing: '-.03rem'}}>
                          {t(`${storeId}:itemNames.${itemDetail.itemId}.${currentLng}`)}
                        </Typography>
                      </Box>
                      {/* 실제 이미지 */}
                      <img 
                        style={{
                          width: '100%', 
                          height: `calc(${width/10 * .36} * 16px)`, 
                          position: 'relative', 
                          zIndex: 2,
                          borderRadius: '1.5rem',
                          objectFit: 'cover'
                        }}
                        src={imageSrc}
                        alt="item"
                      />
                    </Box>
                  )}
                  <Stack sx={{width: '50.5rem', justifyContent: 'flex-end', alignItems: 'flex-start'}}>
                    <Typography id="item-title" sx={{ fontSize: '3.0rem', fontWeight: '600', fontStyle:'normal', lineHeight: '3.0rem', letterSpacing: '-.024rem', width: '50.5rem', maxHeight: '7.2rem'}}>
                    {t(`${storeId}:itemNames.${itemDetail.itemId}.${currentLng}`)}
                    </Typography>
                    <Typography id="item-price" sx={{fontSize: itemDetail.isPriceVisible? '2.2rem': '1.8rem', fontWeight: '600', fontStyle:'normal', height: '3.0rem', textAlign: 'left', my: '.4rem' }}>
                      {itemDetail.isPriceVisible? `$${(itemDetail?.itemPrice/100).toFixed(2)}` : "Priced by add-ons"}
                    </Typography>
                  </Stack>
                </Stack>
                {!itemDetail.hasModifier && itemDetail.enableDesc && <Box sx={{width: '100%', height: '16.8rem', overflow:'overlay', overflowX: 'hidden', mt: '.5rem'}}>
                  <Typography id="item-price" sx={{fontSize: '2.2rem', whiteSpace: 'pre-line', fontWeight: '400', fontStyle: 'normal'}}>
                    {t(`${storeId}:itemDescs.${itemDetail.itemId}.${currentLng}`)}
                  </Typography>
                </Box>}
                {/* {scrollPosition > 0 ?         
                  <Typography id="item-title" sx={{position: 'sticky', top: '0rem', zIndex: 1,  fontSize: '30rem', fontWeight: '600', fontStyle:'normal', lineHeight: '30rem', letterSpacing: '-0.24rem', width: '692rem', maxHeight: '72rem'}}>
                    {t(`${storeId}:itemNames.${itemDetail.itemId}.${currentLng}`)}
                  </Typography>: <></>
                } */}
                {itemDetail.hasModifier ?
                    // <List style={{ padding: 0}}>
                      <Modifier itemDetail={itemDetail} setItemDetail={setItemDetail} setSelectRequired={setSelectRequired} checkedModifierPrice={checkedModifierPrice} />
                    // </List> 
                  : <Box></Box>
                }
                {/* {tableInfo.isKioskMode ? <CustomRequest itemDetail={itemDetail} setItemDetail={setItemDetail}/> : <></>} */}
                {/* <CustomRequest itemDetail={itemDetail} setItemDetail={setItemDetail}/> */}
                { itemDetail.hasRecommend ? <RecommendView itemDetail={itemDetail} /> : <></>}

              </Box>
            </Box>
            {(itemDetail.useAgeVerification && itemDetail.requiresAgeVerification && !itemDetail.isAgeVerified) ? 
              <Box sx={{position: 'fixed', bottom: '0rem', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Box sx={{display: 'flex', flexDirection:'row', justifyContent: 'center', alignItems: 'flex-start', background: '#fff' , width: '100%', borderRadius: 0, mt: '3.0rem', mb: '3.0rem',  height: '5.5rem'}}>
                  {/* <img style={{marginRight: '1.3rem', marginLeft: '.4rem', width: '4.0rem', height: '4.0rem'}}
                    src={process.env.PUBLIC_URL+'/assets/images/21+.svg'}
                    alt="cart"
                  />  */}
                  <Typography sx={{fontSize: '2.4rem', fontWeight:'600'}}>Please ask your server to order this item.</Typography>
                </Box>
              </Box> :
                !itemDetail.hasModifier && (<Box sx={{
                  position: 'fixed',
                  bottom: '0rem',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: '#fff'
                }}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    width: '100%', 
                    borderRadius: 0, 
                    pt: '3.0rem', 
                    pb: '3.0rem',
                    maxWidth: '50.5rem'
                  }}>
                    {(itemDetail.maxAllowed || itemDetail.minRequired! > 1) &&
                      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', mr: '1.0rem', alignItems: 'center', height: '5.5rem' }}>
                        <img style={{width: '3.9rem', height: '3.9rem'}}
                          src={process.env.PUBLIC_URL+'/assets/images/warning_r.svg'}
                          alt="warning"
                        />
                        <Typography sx={{fontSize: '2.6rem', fontWeight: '600', color: '#F72E13'}}>
                          {checkLimitCountText()}
                        </Typography>
                      </Box>
                    }
                    <Box sx={{
                      display: 'flex', 
                      flexDirection: 'row', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      width: '100%',
                      gap: '4.0rem'
                    }}>
                      <Box sx={{
                        display: 'flex', 
                        flexDirection: 'row', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        width:'17.2rem', 
                        height:'5.5rem',
                        padding: '.4rem 1.4rem', 
                        borderRadius: '5.5rem', 
                        backgroundColor: '#fff', 
                        border: '2px solid #E9E9E9', 
                        gap: '2.0rem'
                      }}>
                        <div className="touch-area" onClick={(e: React.MouseEvent<HTMLDivElement>) => handleSubCount()}>
                          <IconButton sx={{p : '0rem'}}
                            aria-label="minus">
                            <LazyPicture sx={{background: '#fff', width: '2.6rem' , height: '2.6rem'}}
                              src={process.env.PUBLIC_URL+'/assets/images/minus.svg'}
                              alt="minus"
                            />
                          </IconButton>
                        </div>
                        <Typography id="item-price" sx={{fontSize: '2.2rem', fontWeight: '700', fontStyle: 'normal', width: '6.0rem', lineHeight: 'normal', textAlign: 'center'}}>
                          {itemDetail.quantity}
                        </Typography>
                        <div className="touch-area" onClick={(e: React.MouseEvent<HTMLDivElement>) => handleAddCount()}>
                          <IconButton sx={{p : '0rem'}}
                            aria-label="plus">
                            <LazyPicture sx={{background: '#fff', width:  '2.6rem' , height: '2.6rem'}}
                              src={process.env.PUBLIC_URL+'/assets/images/add.svg'}
                              alt="add"
                            />
                          </IconButton>
                        </div>
                      </Box>
                      <div className="touch-area" onClick={(e: React.MouseEvent<HTMLDivElement>) => handleAddtoCart(e, itemDetail)}>
                        <ButtonBase sx={{width: '32.0rem', padding: '.6rem 2.0rem', justifyContent: 'center', height: '5.5rem', backgroundColor: '#DA291C', borderRadius: '5.5rem'}}>
                            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                              <Typography sx={{fontSize: '2.2rem', fontWeight: '600', fontStyle: 'normal', letterSpacing: '-.022rem', textTransform:' none', width: 'auto', color: '#fff', textAlign: 'center', textWrap: 'noWrap'}}>Add to Cart</Typography>
                              <Typography sx={{fontSize: '2.2rem', fontWeight: '600', fontStyle: 'normal', letterSpacing: '-.022rem', textTransform:' none', width: 'auto', color: '#fff', textAlign: 'center', ml: '1.0rem'}}>${(itemDetail.quantity * orderTotalPrice/100).toFixed(2)}</Typography>
                            </Box>
                        </ButtonBase>
                      </div>
                    </Box>
                  </Box>
                </Box>)
            } 
          </Box>
        </Box>
        {itemDetail.hasModifier && 
          <Box sx={{position: 'absolute', right: '.5rem', bottom: 0}}>
            <div className="touch-area"  onClick={(e: React.MouseEvent<HTMLDivElement>) => handleOpenOrderBox(e as any)}>
              <ButtonBase sx={[{ backgroundColor: '#F72E13', borderRadius : '1.5rem 1.5rem 0rem 0rem', boxShadow: '0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.35)', textTransform: 'none',
                padding: '1.2rem 2.6rem', width: '100%', display: 'flex', flexDirection: 'row',height: '7rem', alignItems: 'center', justifyContent: 'center', zIndex: 999}]}>
                  <Stack sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                    {/* <img style={{width: '3.5rem', height: '3.4rem'}}
                      src={process.env.PUBLIC_URL+'/assets/images/cart.svg'}
                      alt="orderbox"
                    /> */}
                    <Typography sx={{color: '#fff', fontSize: '20px', fontStyle: 'normal', fontWeight: '600', letterSpacing: '-.028rem', mb: 0, textWrap: 'nowrap', mr: '.5rem'}}>Add to Cart</Typography>
                  </Stack>
              </ButtonBase>
            </div>
          </Box>
        }
        <DrawerOrderBox openOrderBox={openOrderBox} setOpenOrderBox={setOpenOrderBox} checkLimitText={checkLimitCountText} selectRequired={selectRequired} setSelectRequired={setSelectRequired} />
    </Box>
    )
  }

  export default PortraitDetail
